module.exports = require("@mui/material/DialogContent");